<template>
  <svg class="p-animated-icon" :class="classComputed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
    <circle class="se-shape" cx="26" cy="26" r="25" fill="none" />

    <path v-if="props.icon === 'success'" class="se-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />

    <path v-if="props.icon === 'close'" class="se-path" fill="none" d="M 16.105187,35.954063 35.894813,16.045937" />
    <path v-if="props.icon === 'close'" class="se-path" fill="none" d="M 35.894813,35.954063 16.105187,16.045937" />
  </svg>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";

// Props
const props = defineProps({
  icon: {
    type: String as PropType<"success" | "close">,
    required: false,
    default: "success",
  },
  class: {
    type: String,
    required: false,
  },
});

// Computed
const classComputed = computed(() => {
  const result = [props.class];

  if (props.icon === "success") {
    result.push("success");
  } else if (props.icon === "close") {
    result.push("danger");
  }

  return result;
});
</script>
